import httpInstance from "./server"

export default function Get(props){
    if(!props.secure){
        return httpInstance.get(props.url, {        
            headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json",
            }
        })            
    }else{
        return httpInstance.get(props.url, {        
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${props.access_token}`,
                "Accept": "application/json",
            }
        })
    }  

}